import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button, ButtonGroup } from "aible";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import styles from "./style.module.css";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";
import * as aiServiceReducer from "@/containers/AiService/reducer";
import { CronJobs } from "components/Templates/AgentC";
import { initOpenAibleClawAgent } from "@/containers/View/reducer";
const CreateClawFromChat = ({}) => {
    const dispatch = useDispatch();
    const [isSavingAgent, setIsSavingAgent] = useState(false);
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const savedClawAgentId = useSelector((state) => {
        const savedId = chatGPTReducer.getClawAgentId(state);
        const savedAgent = aibleAnywhereReducer.getAibleAnywhere(state, savedId);
        // Make sure we can access the saved agent before returning the linkedId
        if (savedAgent) {
            return savedId;
        }
        return undefined;
    });
    // this is either the linked agent or a new agent we make from the chat settings
    const getDefaultAgent = () => dispatch((dispatch, getState) => {
        if (savedClawAgentId) {
            // we don't need to check we have access to this because savedClawAgentId already checks it
            return aibleAnywhereReducer.getAibleAnywhere(getState(), savedClawAgentId);
        }
        return aibleAnywhereReducer.getClawAgentFromChat(getState());
    });
    const questionIndex = useSelector((state) => chatGPTReducer.getQuestionIndex(state));
    const agentIqBaseModel = useSelector((state) => chatGPTReducer.getAgentIQBaseModel(state));
    const selectedAgentIqBaseModel = useSelector((state) => agentIqBaseModel && !isNaN(Number(agentIqBaseModel))
        ? aiServiceReducer.getModelById(state, agentIqBaseModel)
        : undefined);
    const useGuardrails = useSelector((state) => Boolean(chatGPTReducer.getGuardrails(state)));
    const useCache = useSelector((state) => chatGPTReducer.getMaxCacheAge(state) !== undefined);
    const [agent, setAgent] = useState(getDefaultAgent());
    const hasValidAgent = aibleAnywhereReducer.isValidClawAgent(agent);
    const disableCreateAgent = !hasValidAgent;
    const handleSaveAgent = async (saveNext = false) => {
        setIsSavingAgent(true);
        let sAgent;
        try {
            // save the agent
            sAgent = await dispatch(aibleAnywhereReducer.saveClawAgent(agent, agent?.name, true));
            // link agent to current project
            // checking for ids handles the case of deleting a linked agent and saving a new one
            if (sAgent?.id && sAgent.id !== savedClawAgentId) {
                dispatch(chatGPTReducer.updateClawAgentId(sAgent.id));
            }
            // save project
            if (saveNext) {
                dispatch(chatGPTReducer.handleAutoSave());
            }
        }
        catch (e) {
            console.log(e);
        }
        // Align state with the newly saved agent
        const newAgent = dispatch((dispatch, getState) => aibleAnywhereReducer.getAibleAnywhere(getState(), sAgent?.id));
        setAgent(newAgent);
        setIsSavingAgent(false);
        return newAgent;
    };
    const forceCronTest = async (cronJob, index) => {
        //dispatch(chatGPTReducer.submitQuestion({ overwritePrompt: cronJob?.prompt }));
        await dispatch(aibleAnywhereReducer.testCronWithDataset(cronJob));
        return Promise.resolve();
        /*
        // save the current agent to save changes
        const sAgent = await handleSaveAgent();
    
        let retBlueprintOptions = [...(cronJob?.blueprintOptions ?? [])];
    
        if (aibleAnywhereReducer.shouldInjectSlackTool(cronJob)) {
          retBlueprintOptions.push({
            id: 11,
            third_party_tool_id: cronJob?.slackChannel?.value,
            name: "post_report_to_channel"
          });
        }
        dispatch(
          chatGPTReducer.handleAgentIQ(
            cronJob?.prompt,
            false,
            "reasoning",
            cronJob?.executionMetadata?.execution_id,
            sAgent?.id,
            retBlueprintOptions,
            useCache
          )
        );
        */
    };
    useEffect(() => {
        const defaultAgent = getDefaultAgent();
        setAgent(defaultAgent);
    }, []);
    useEffect(() => {
        const defaultAgent = getDefaultAgent();
        setAgent(defaultAgent);
    }, [questionIndex]);
    return (React.createElement("div", { className: styles.createClawWrapper },
        agent?.id !== undefined && savedClawAgentId ? (React.createElement("div", { className: styles.createClawHeader },
            React.createElement("div", { className: styles.agentCInput, style: { marginBottom: "0px" } },
                React.createElement("div", { className: styles.agentCInputBold }, "Enable Agent"),
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { onClick: (e) => setAgent({ ...agent, ["isEnabled"]: true }), active: agent?.isEnabled === true }, "Enabled"),
                    React.createElement(Button, { onClick: (e) => setAgent({ ...agent, ["isEnabled"]: false }), active: agent?.isEnabled !== true }, "Disabled"))))) : null,
        React.createElement("div", { className: styles.createClawBody },
            React.createElement(CronJobs, { agentC: agent, updateAgentC: (key, data) => {
                    return setAgent({ ...agent, [key]: data });
                }, useGuardrails: useGuardrails, open: true, useCache: useCache, hideCommunicationChannels: true, forceTest: forceCronTest, hideCreate: true, hideDelete: true, hideTools: true, hideSetupStepDisplay: true })),
        React.createElement("div", { className: styles.createClawActions },
            React.createElement(Button, { style: { marginLeft: "auto" }, type: savedClawAgentId ? "secondary" : "primary", onClick: () => handleSaveAgent(true), isLoading: isSavingAgent, disabled: disableCreateAgent }, savedClawAgentId ? "Update Long Running Agent" : "Create Long Running Agent"),
            agent?.id !== undefined && savedClawAgentId ? (React.createElement(Button, { style: { marginLeft: "10px" }, type: "secondary", onClick: () => dispatch(initOpenAibleClawAgent(savedClawAgentId)), disabled: isSavingAgent }, "Open Long Running Agent")) : null)));
};
export default CreateClawFromChat;
